<template>
  <div :class="$style.kioskMenuHeader">
    <button v-if="isMenuHeader"
            :class="[$style.kioskMenuBtn, $style.kioskExitBtn]"
            @click="handleLogoClick">
      <svg v-svg
           :class="$style.headerMenuIcon"
           symbol="exit-icon" />
    </button>
    <button v-else
            :class="$style.kioskMenuBtn"
            @click="handleMenuClick">
      <svg v-svg
           :class="$style.headerMenuIcon"
           symbol="menu-icon" /> Menu
    </button>

    <img src="@/assets/img/white.png"
         alt="Burger Boss"
         @click="handleLogoClick" >

    <KioskCartIcon />
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import KioskCartIcon from '@/components/KioskCartIcon';
import { Action, Getter } from 'vuex-class';
import { MODAL_UPDATE } from '@/apps/core/store/types';

/**
 * Provides header for menu pages
 */
@Component({
  components: {
    KioskCartIcon,
  },
  props: {
    isMenuHeader: {
      type:     Boolean,
      default:  false,
      required: false,
    },
  },
})
export default class KioskMenuHeader extends Vue {
  @Getter orderItemCompleted;
  @Action(MODAL_UPDATE) modalUpdate;

  handleMenuClick() {
    if (!this.orderItemCompleted) {
      this.modalUpdate({ name: 'goToMenuOrMain', data: 'menu' });
    } else {
      this.$router.push({ name: 'menu' });
    }
  }

  handleLogoClick() {
    this.modalUpdate({ name: 'cartOrderCancel', data: true });
  }
}
</script>

<style lang="scss" module>
@import '~@/style/variables.scss';
.kioskMenuHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 115px;
  padding: 16px 27px;
  background-color: $white;
  box-shadow: 0 1px 5px 0 rgba(139, 139, 139, 0.81);
  position: relative;
  z-index: 10;
}

.kioskMenuBtn {
  display: flex;
  align-items: center;
  font-family: 'Gotham', sans-serif;
  font-size: 34px;
  line-height: 48px;
  font-weight: 300;
  outline: none;
  .headerMenuIcon {
    width: 59px;
    height: 54px;
    margin-right: 31px;
  }
}
.kioskExitBtn {
  width: 180px;
}
</style>



// WEBPACK FOOTER //
// src/apps/kiosk/components/KioskMenuHeader.vue